import { AppConstants } from './constants';
import { ICodeAndLinkIdForObservations } from 'src/interfaces/utility-interfaces';
import { fhirR4 } from '@smile-cdr/fhirts';

export class ClinicalConstants {
  public static referralObservationsList: ICodeAndLinkIdForObservations[] = [
    {
      code: AppConstants.RACE_OBSERVATION_CODE,
      linkId: AppConstants.raceLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.RACE_CODE_SYSTEM
    },
    {
      code: AppConstants.SECONDARY_REFERRAL_REASON_OBSERVATION_CODE,
      linkId: AppConstants.secondaryReasonReferralLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.REFERRAL_REASON_CODE_SYSTEM
    },
    {
      code: AppConstants.SECONDARY_REFERRAL_REASON_TYPE_OBSERVATION_CODE,
      linkId: AppConstants.secondaryReasonReferralTypeLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.REFERRAL_REASON_TYPE_CODE_SYSTEM
    },
    {
      code: AppConstants.PATIENT_REFERRAL_POSTAL_CODE_OBSERVATION_CODE,
      linkId: AppConstants.PATIENT_REFERRAL_POSTAL_CODE_LINK_ID,
      answerType: AppConstants.VALUE_TYPE_STRING
    }
  ];
  public static waitTimesObservationsList: ICodeAndLinkIdForObservations[] = [
    {
      code: AppConstants.RMWT_OBSERVATION_CODE,
      linkId: AppConstants.recommendedMaximumWaitTimeLinkId,
      answerType: AppConstants.VALUE_TYPE_INTEGER
    },
    {
      code: AppConstants.WAIT_TIME_1_OBSERVATION_CODE,
      linkId: AppConstants.waitTime1LinkId,
      answerType: AppConstants.VALUE_TYPE_INTEGER
    },
    {
      code: AppConstants.WAIT_TIME_2_OBSERVATION_CODE,
      linkId: AppConstants.waitTime2LinkId,
      answerType: AppConstants.VALUE_TYPE_INTEGER
    },
    {
      code: AppConstants.PRIORITY_LEVEL_OBSERVATION_CODE,
      linkId: AppConstants.priorityLevelLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.PRIORITY_LEVEL_CODE_SYSTEM
    },
    {
      code: AppConstants.URS_OBSERVATION_CODE,
      linkId: AppConstants.urgencyRatingScoreLinkId,
      answerType: AppConstants.VALUE_TYPE_QUANTITY
    },
    {
      code: AppConstants.ANATOMY_RESULT_OBSERVATION_CODE,
      linkId: AppConstants.calculationAnatomyResultLinkId,
      answerType: AppConstants.VALUE_TYPE_STRING,
      observationCodeSystem: AppConstants.WAIT_TIMES_AND_METRICS_OBSERVATIONS_CODE_SYSTEM
    },
    {
      code: AppConstants.CS_OBSERVATION_CODE,
      linkId: AppConstants.calculationCsLinkId,
      answerType: AppConstants.VALUE_TYPE_STRING,
      observationCodeSystem: AppConstants.WAIT_TIMES_AND_METRICS_OBSERVATIONS_CODE_SYSTEM
    },
    {
      code: AppConstants.CC_OBSERVATION_CODE,
      linkId: AppConstants.calculationCcLinkId,
      answerType: AppConstants.VALUE_TYPE_STRING,
      observationCodeSystem: AppConstants.WAIT_TIMES_AND_METRICS_OBSERVATIONS_CODE_SYSTEM
    },
    {
      code: AppConstants.CI_OBSERVATION_CODE,
      linkId: AppConstants.calculationCiLinkId,
      answerType: AppConstants.VALUE_TYPE_STRING,
      observationCodeSystem: AppConstants.WAIT_TIMES_AND_METRICS_OBSERVATIONS_CODE_SYSTEM
    },
    {
      code: AppConstants.CA_OBSERVATION_CODE,
      linkId: AppConstants.calculationCaLinkId,
      answerType: AppConstants.VALUE_TYPE_STRING,
      observationCodeSystem: AppConstants.WAIT_TIMES_AND_METRICS_OBSERVATIONS_CODE_SYSTEM
    },
    {
      code: AppConstants.CV_OBSERVATION_CODE,
      linkId: AppConstants.calculationCvLinkId,
      answerType: AppConstants.VALUE_TYPE_STRING,
      observationCodeSystem: AppConstants.WAIT_TIMES_AND_METRICS_OBSERVATIONS_CODE_SYSTEM
    },
    {
      code: AppConstants.CM_OBSERVATION_CODE,
      linkId: AppConstants.calculationCmLinkId,
      answerType: AppConstants.VALUE_TYPE_STRING,
      observationCodeSystem: AppConstants.WAIT_TIMES_AND_METRICS_OBSERVATIONS_CODE_SYSTEM
    },
    {
      code: AppConstants.CP_OBSERVATION_CODE,
      linkId: AppConstants.calculationCpLinkId,
      answerType: AppConstants.VALUE_TYPE_STRING,
      observationCodeSystem: AppConstants.WAIT_TIMES_AND_METRICS_OBSERVATIONS_CODE_SYSTEM
    },
    {
      code: AppConstants.WAIT_TIME_1_DART_DAYS_OBSERVATION_CODE,
      linkId: AppConstants.waitTime1DartDaysLinkId,
      answerType: AppConstants.VALUE_TYPE_INTEGER,
      observationCodeSystem: AppConstants.WAIT_TIMES_AND_METRICS_OBSERVATIONS_CODE_SYSTEM
    },
    {
      code: AppConstants.WAIT_TIME_2_DART_DAYS_OBSERVATION_CODE,
      linkId: AppConstants.waitTime2DartDaysLinkId,
      answerType: AppConstants.VALUE_TYPE_INTEGER,
      observationCodeSystem: AppConstants.WAIT_TIMES_AND_METRICS_OBSERVATIONS_CODE_SYSTEM
    }
  ];
  public static offlistingObservationsListForServiceRequest: ICodeAndLinkIdForObservations[] = [
    {
      code: AppConstants.REMOVAL_REASON_OBSERVATION_CODE,
      linkId: AppConstants.removalReasonFieldLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.REMOVAL_REASON_CODE_SYSTEM
    }
  ];
  public static acceptanceObservationsListForServiceRequest: ICodeAndLinkIdForObservations[] = [
    {
      code: AppConstants.DART_FROM_OBSERVATION_CODE,
      linkId: AppConstants.datesAffectingReadinessToTreatFromDateLinkId,
      answerType: AppConstants.VALUE_TYPE_PERIOD
    },
    {
      code: AppConstants.DART_TO_OBSERVATION_CODE,
      linkId: AppConstants.datesAffectingReadinessToTreatToDateLinkId,
      answerType: AppConstants.VALUE_TYPE_PERIOD
    },
    {
      code: AppConstants.DELAY_REASON_OBSERVATION_CODE,
      linkId: AppConstants.delayReasonLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.DELAY_REASON_CODE_SYSTEM
    },
    {
      code: AppConstants.HEART_TEAM_INVOLVED_IN_TREATMENT_DECISION_OBSERVATION_CODE,
      linkId: AppConstants.heartTeamInvolvedInTreatmentDecisionLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.FUNDING_SOURCE_OBSERVATION_CODE,
      linkId: AppConstants.fundingSourceLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.FUNDING_SOURCE_CODE_SYSTEM
    }
  ];
  public static procedureObservationList: ICodeAndLinkIdForObservations[] = [
    {
      code: AppConstants.INTRA_AORTIC_BALLOON_PUMP_OBSERVATION_CODE,
      linkId: AppConstants.intraAorticBalloonPumpLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.PRESENCE_OF_CORONARY_STENOSIS_OBSERVATION_CODE,
      linkId: AppConstants.presenceOfStenosisLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.PRESENCE_OF_CORONARY_STENOSIS_CODE_SYSTEM
    },
    {
      code: AppConstants.STENOSIS_OF_THE_LEFT_MAIN_ARTERY_OBSERVATION_CODE,
      linkId: AppConstants.stenosisOfTheLeftMainArteryLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENOSIS_OF_THE_LEFT_MAIN_ARTERY_CODE_SYSTEM
    },
    {
      code: AppConstants.STENOSIS_OF_THE_PROXIMAL_LEFT_ANTERIOR_DESCENDING_ARTERY_OBSERVATION_CODE,
      linkId: AppConstants.stenosisOfTheProximalLeftAnteriorDescendingArteryLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENOSIS_OF_THE_PROXIMAL_LEFT_ANTERIOR_DESCENDING_ARTERY_CODE_SYSTEM
    },
    {
      code: AppConstants.STENOSIS_OF_THE_MID_DISTAL_LEFT_ANTERIOR_DESCENDING_ARTERY_OBSERVATION_CODE,
      linkId: AppConstants.stenosisOfTheMidDistalLeftAnteriorDescendingArteryLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENOSIS_OF_THE_MID_DISTAL_LEFT_ANTERIOR_DESCENDING_ARTERY_CODE_SYSTEM
    },
    {
      code: AppConstants.STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_OBSERVATION_CODE,
      linkId: AppConstants.stenosisOfTheCircumflexArteryLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_CODE_SYSTEM
    },
    {
      code: AppConstants.STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_OBSERVATION_CODE,
      linkId: AppConstants.stenosisOfTheRightCoronaryArteryLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_CODE_SYSTEM
    },
    {
      code: AppConstants.STENOSIS_OF_THE_LEFT_ANTERIOR_DESCENDING_ARTERY_GRAFT_124_OBSERVATION_CODE,
      linkId: AppConstants.stenosisOfTheLeftAnteriorDescendingArteryGraftLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENOSIS_OF_THE_LEFT_ANTERIOR_DESCENDING_ARTERY_GRAFT_124_CODE_SYSTEM
    },
    {
      code: AppConstants.STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_GRAFT_125_OBSERVATION_CODE,
      linkId: AppConstants.stenosisOfTheCircumflexArteryGraftLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_GRAFT_125_CODE_SYSTEM
    },
    {
      code: AppConstants.STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_GRAFT_126_OBSERVATION_CODE,
      linkId: AppConstants.stenosisOfTheRightCoronaryArteryGraftLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_GRAFT_126_CODE_SYSTEM
    },
    {
      code: AppConstants.EXTRACORPOREAL_CARDIOPULMONARY_OBSERVATION_CODE,
      linkId: AppConstants.extracorporealCardiopulmonaryBypassLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.EXTRACORPOREAL_CARDIOPULMONARY_CODE_SYSTEM
    },
    {
      code: AppConstants.VALVE_SURGERY_TYPE_OBSERVATION_CODE,
      linkId: AppConstants.valveSurgeryTypeLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.VALVE_SURGERY_TYPE_CODE_SYSTEM
    },
    {
      code: AppConstants.ATRIAL_FIBRILLATION_ABLATION_TYPE_OBSERVATION_CODE,
      linkId: AppConstants.atrialFibrillationAblationTypeLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.ATRIAL_FIBRILLATION_ABLATION_TYPE_CODE_SYSTEM
    },
    {
      code: AppConstants.ATRIAL_FIBRILLATION_ABLATION_INSTANCE_OBSERVATION_CODE,
      linkId: AppConstants.atrialFibrillationAblationInstanceLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.ATRIAL_FIBRILLATION_ABLATION_INSTANCE_CODE_SYSTEM
    },
    {
      code: AppConstants.CLINICALLY_RELEVANT_PERICARDIAL_EFFUSION_OBSERVATION_CODE,
      linkId: AppConstants.clinicallyRelevantPericardialEffusionLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.DEVICE_EMBOLIZATION_OBSERVATION_CODE,
      linkId: AppConstants.deviceEmbolizationLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.MAJOR_BLEEDING_OBSERVATION_CODE,
      linkId: AppConstants.majorBleedingLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.NUMBER_OF_VALVE_CLIPS_OBSERVATION_CODE,
      linkId: AppConstants.numberOfValveClipsLinkId,
      answerType: AppConstants.VALUE_TYPE_INTEGER
    },
    {
      code: AppConstants.POST_OPERATIVE_MITRAL_REGURGITATION_OBSERVATION_CODE,
      linkId: AppConstants.postOperativeMitralRegurgitationLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.POST_OPERATIVE_MITRAL_REGURGITATION_CODE_SYSTEM
    },
    {
      code: AppConstants.POST_OPERATIVE_MITRAL_VALVE_GRADIENT_OBSERVATION_CODE,
      linkId: AppConstants.postOperativeMitralValveGradientLinkId,
      answerType: AppConstants.VALUE_TYPE_QUANTITY
    },
    {
      code: AppConstants.PERSISTENT_INTER_ATRIAL_SHUNT_POST_PROCEDURE_OBSERVATION_CODE,
      linkId: AppConstants.persistentInterAtrialShuntPostProcedureLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.TECHNICAL_SUCCESS_OBSERVATION_CODE,
      linkId: AppConstants.technicalSuccessLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.VASCULAR_COMPILATION_OBSERVATION_CODE,
      linkId: AppConstants.vascularComplicationLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    }
  ];
  public static stentElements: ICodeAndLinkIdForObservations[] = [
    {
      code: AppConstants.STENT_DEPLOYMENT_LOCATION_OBSERVATION_CODE,
      linkId: AppConstants.stentDeploymentLocationWithoutIndexLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENT_DEPLOYMENT_LOCATION_CODE_SYSTEM
    },
    {
      code: AppConstants.LESION_TYPE_OBSERVATION_CODE,
      linkId: AppConstants.lesionTypeLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.LESION_TYPE_CODE_SYSTEM
    },
    {
      code: AppConstants.CHRONIC_TOTAL_OCCLUSION_RESULT_OBSERVATION_CODE,
      linkId: AppConstants.ChronicTotalOcclusionResultLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.CHRONIC_TOTAL_OCCLUSION_RESULT_CODE_SYSTEM
    },
    {
      code: AppConstants.STENT_TYPE_OBSERVATION_CODE,
      linkId: AppConstants.stentTypeLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENT_TYPE_CODE_SYSTEM
    },
    {
      code: AppConstants.STENT_SIZE_OBSERVATION_CODE,
      linkId: AppConstants.stentSizeLinkId,
      answerType: AppConstants.VALUE_TYPE_QUANTITY
    },
    {
      code: AppConstants.STENT_LENGTH_OBSERVATION_CODE,
      linkId: AppConstants.stentLengthLinkId,
      answerType: AppConstants.VALUE_TYPE_INTEGER
    }
  ];
  public static diagnosticsObservationList: ICodeAndLinkIdForObservations[] = [
    {
      code: AppConstants.CLINICAL_STATUS_CHANGE_DATE_OBSERVATION_CODE,
      linkId: AppConstants.clinicalStatusChangeDateLinkId,
      answerType: AppConstants.VALUE_TYPE_DATETIME
    },
    {
      code: AppConstants.HISTORY_OF_MYOCARDIAL_INFARCTION_OBSERVATION_CODE,
      linkId: AppConstants.historyOfMyocardialInfarctionLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.HISTORY_OF_MYOCARDIAL_INFARCTION_CODE_SYSTEM
    },
    {
      code: AppConstants.CANADIAN_CARDIOVASCULAR_SOCIETY_CLASSIFICATION_OBSERVATION_CODE,
      linkId: AppConstants.canadianCardiovascularSocietyClassificationLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.CANADIAN_CARDIOVASCULAR_SOCIETY_CLASSIFICATION_CODE_SYSTEM
    },
    {
      code: AppConstants.ACUTE_CORONARY_SYNDROME_CLASSIFICATION_OBSERVATION_CODE,
      linkId: AppConstants.acuteCoronarySyndromeClassificationLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.ACUTE_CORONARY_SYNDROME_CLASSIFICATION_CODE_SYSTEM
    },
    {
      code: AppConstants.CARDIOGENIC_SHOCK_OBSERVATION_CODE,
      linkId: AppConstants.cardiogenicShockLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.NEW_YORK_HEART_ASSOCIATION_FUNCTIONAL_CLASSIFICATION_OBSERVATION_CODE,
      linkId: AppConstants.newYorkHeartAssociationFunctionalClassificationLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.NEW_YORK_HEART_ASSOCIATION_FUNCTIONAL_CLASSIFICATION_CODE_SYSTEM
    },
    {
      code: AppConstants.REST_ELECTROCARDIOGRAM_ISCHEMIC_CHANGES_OBSERVATION_CODE,
      linkId: AppConstants.restElectrocardiogramIschemicChangesLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.REST_ELECTROCARDIOGRAM_ISCHEMIC_CHANGES_CODE_SYSTEM
    },
    {
      code: AppConstants.EXERCISE_ELECTROCARDIOGRAM_OBSERVATION_CODE,
      linkId: AppConstants.exerciseElectrocardiogramRiskLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.EXERCISE_ELECTROCARDIOGRAM_CODE_SYSTEM
    },
    {
      code: AppConstants.FUNCTIONAL_IMAGING_RISK_OBSERVATION_CODE,
      linkId: AppConstants.functionalImagingRiskLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.FUNCTIONAL_IMAGING_RISK_CODE_SYSTEM
    },
    {
      code: AppConstants.LEFT_VENTRICULAR_EJECTION_FRACTION_OBSERVATION_CODE,
      linkId: AppConstants.leftVentricularEjectionFractionLinkId,
      answerType: AppConstants.VALUE_TYPE_INTEGER
    },
    {
      code: AppConstants.LEFT_VENTRICULAR_EJECTION_FRACTION_GRADE_OBSERVATION_CODE,
      linkId: AppConstants.leftVentricularEjectionFractionGradeLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.LEFT_VENTRICULAR_EJECTION_FRACTION_GRADE_CODE_SYSTEM
    },
    {
      code: AppConstants.SERUM_CREATININE_OBSERVATION_CODE,
      linkId: AppConstants.serumCreatinineLinkId,
      answerType: AppConstants.VALUE_TYPE_INTEGER
    },
    {
      code: AppConstants.DIALYSIS_OBSERVATION_CODE,
      linkId: AppConstants.dialysisLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.DIABETES_OBSERVATION_CODE,
      linkId: AppConstants.diabetesLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.HISTORY_OF_TOBACCO_USE_OBSERVATION_CODE,
      linkId: AppConstants.historyOfTobaccoUseLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.HISTORY_OF_TOBACCO_USE_CODE_SYSTEM
    },
    {
      code: AppConstants.CEREBRAL_VASCULAR_DISEASE_OBSERVATION_CODE,
      linkId: AppConstants.cerebralVascularDiseaseLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.CHRONIC_OBSTRUCTIVE_PULMONARY_DISEASE_OBSERVATION_CODE,
      linkId: AppConstants.chronicObstructivePulmonaryDiseaseLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.HISTORY_OF_CORONARY_ARTERY_BYPASS_GRAFT_SURGERY_OBSERVATION_CODE,
      linkId: AppConstants.historyOfCoronaryArteryBypassGraftSurgeryLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.ENDOCARDITIS_OBSERVATION_CODE,
      linkId: AppConstants.endocarditisLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.ENDOCARDITIS_CODE_SYSTEM
    },
    {
      code: AppConstants.HISTORY_OF_CONGESTIVE_HEART_FAILURE_OBSERVATION_CODE,
      linkId: AppConstants.historyOfCongestiveHeartFailureLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.HEIGHT_OBSERVATION_CODE,
      linkId: AppConstants.diagnosticHeightLinkId,
      answerType: AppConstants.VALUE_TYPE_INTEGER
    },
    {
      code: AppConstants.WEIGHT_OBSERVATION_CODE,
      linkId: AppConstants.diagnosticWeightLinkId,
      answerType: AppConstants.VALUE_TYPE_INTEGER
    },
    {
      code: AppConstants.PRE_PROCEDURAL_MITRAL_REGURGITATION_OBSERVATION_CODE,
      linkId: AppConstants.preProceduralMitralRegurgitationLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.PRE_PROCEDURAL_MITRAL_REGURGITATION_CODE_SYSTEM
    },
    {
      code: AppConstants.MITRAL_REGURGITATION_TYPE_OBSERVATION_CODE,
      linkId: AppConstants.mitralRegurgitationTypeLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.MITRAL_REGURGITATION_TYPE_CODE_SYSTEM
    },
    {
      code: AppConstants.MITRAL_VALVE_ORIFICE_AREA_OBSERVATION_CODE,
      linkId: AppConstants.mitralValveOrificeAreaLinkId,
      answerType: AppConstants.VALUE_TYPE_QUANTITY
    },
    {
      code: AppConstants.PULMONARY_ARTERY_SYSTOLIC_PRESSURE_OBSERVATION_CODE,
      linkId: AppConstants.pulmonaryArterySystolicPressureLinkId,
      answerType: AppConstants.VALUE_TYPE_QUANTITY
    },
    {
      code: AppConstants.LEFT_MAIN_LESION_WITHOUT_BYPASS_GRAFT_OBSERVATION_CODE,
      linkId: AppConstants.leftMainLesionWithoutBypassGraftLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.THREE_VESSEL_DISEASE_OBSERVATION_CODE,
      linkId: AppConstants.threeVesselDiseaseWithProximalLeftAnteriorDescendingArteryLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.VEIN_GRAFT_LESION_OBSERVATION_CODE,
      linkId: AppConstants.veinGraftLesionLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.SURVIVAL_DEPENDENT_VESSEL_OBSERVATION_CODE,
      linkId: AppConstants.survivalDependentVesselLinkId,
      answerType: AppConstants.VALUE_TYPE_BOOLEAN
    },
    {
      code: AppConstants.NATIVE_STENOSIS_OF_THE_LEFT_MAIN_ARTERY_OBSERVATION_CODE,
      linkId: AppConstants.nativeStenosisOfTheLeftMainArteryLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.NATIVE_STENOSIS_OF_THE_LEFT_MAIN_ARTERY_CODE_SYSTEM
    },
    {
      code: AppConstants.NATIVE_STENOSIS_OF_THE_PROXIMAL_LEFT_ANTERIOR_DESCENDING_ARTERY_OBSERVATION_CODE,
      linkId: AppConstants.nativeStenosisOfTheProximalLeftAnteriorDescendingArteryLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.NATIVE_STENOSIS_OF_THE_PROXIMAL_LEFT_ANTERIOR_DESCENDING_ARTERY_CODE_SYSTEM
    },
    {
      code: AppConstants.NATIVE_STENOSIS_OF_THE_PROXIMAL_MID_DISTAL_LEFT_ANTERIOR_DESCENDING_ARTERY_OBSERVATION_CODE,
      linkId: AppConstants.nativeStenosisOfTheMidDistalLeftAnteriorDescendingArteryLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.NATIVE_STENOSIS_OF_THE_PROXIMAL_MID_DISTAL_LEFT_ANTERIOR_DESCENDING_ARTERY_CODE_SYSTEM
    },
    {
      code: AppConstants.NATIVE_STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_OBSERVATION_CODE,
      linkId: AppConstants.nativeStenosisOfTheCircumflexArteryLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.NATIVE_STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_CODE_SYSTEM
    },
    {
      code: AppConstants.NATIVE_STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_OBSERVATION_CODE,
      linkId: AppConstants.nativeStenosisOfTheRightCoronaryArteryLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.NATIVE_STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_CODE_SYSTEM
    },
    {
      code: AppConstants.STENOSIS_OF_THE_LEFT_ANTERIOR_DESCENDING_ARTERY_GRAFT_OBSERVATION_CODE,
      linkId: AppConstants.stenosisOfTheLeftAnteriorDescendingArteryGraftLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENOSIS_OF_THE_LEFT_ANTERIOR_DESCENDING_ARTERY_GRAFT_CODE_SYSTEM
    },
    {
      code: AppConstants.STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_GRAFT_OBSERVATION_CODE,
      linkId: AppConstants.stenosisOfTheCircumflexArteryGraftLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENOSIS_OF_THE_CIRCUMFLEX_ARTERY_GRAFT_CODE_SYSTEM
    },
    {
      code: AppConstants.STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_GRAFT_OBSERVATION_CODE,
      linkId: AppConstants.stenosisOfTheRightCoronaryArteryGraftLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.STENOSIS_OF_THE_RIGHT_CORONARY_ARTERY_GRAFT_CODE_SYSTEM
    },
    {
      code: AppConstants.IMPLANT_STATUS_OBSERVATION_CODE,
      linkId: AppConstants.implantStatusLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.IMPLANT_STATUS_CODE_SYSTEM
    },
    {
      code: AppConstants.DEVICE_INDICATION_OBSERVATION_CODE,
      linkId: AppConstants.deviceIndicationLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.DEVICE_INDICATION_CODE_SYSTEM
    },
    {
      code: AppConstants.PATIENT_PRESENTATION_OBSERVATION_CODE,
      linkId: AppConstants.patientPresentationLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.PATIENT_PRESENTATION_CODE_SYSTEM
    },
    {
      code: AppConstants.FIBRINOLYSIS_ADMINISTERED_OBSERVATION_CODE,
      linkId: AppConstants.fibrinolysisAdministeredLinkId,
      answerType: AppConstants.VALUE_TYPE_CODEABLE_CONCEPT,
      answerCodeSystem: AppConstants.FIBRINOLYSIS_ADMINISTERED_CODE_SYSTEM
    },
    {
      code: AppConstants.FIRST_CONTACT_WITH_PARAMEDICS_OBSERVATION_CODE,
      linkId: AppConstants.firstContactParamedicsLinkId,
      answerType: AppConstants.VALUE_TYPE_DATETIME
    },
    {
      code: AppConstants.AMBULANCE_ELECTROCARDIOGRAM_DATE_TIME_OBSERVATION_CODE,
      linkId: AppConstants.ambulanceEcgLinkId,
      answerType: AppConstants.VALUE_TYPE_DATETIME
    },
    {
      code: AppConstants.REGISTRATION_DATE_TIME_OBSERVATION_CODE,
      linkId: AppConstants.registrationDateLinkId,
      answerType: AppConstants.VALUE_TYPE_DATETIME
    },
    {
      code: AppConstants.FIRST_HOSPITAL_ELECTROCARDIOGRAM_DATE_TIME_OBSERVATION_CODE,
      linkId: AppConstants.firstHospitalEcgLinkId,
      answerType: AppConstants.VALUE_TYPE_DATETIME
    },
    {
      code: AppConstants.QUALIFYING_ELECTROCARDIOGRAM_DATE_TIME_OBSERVATION_CODE,
      linkId: AppConstants.qualifyingElectrocardiogramDatetimeLinkId,
      answerType: AppConstants.VALUE_TYPE_DATETIME
    },
    {
      code: AppConstants.FIBRINOLYSIS_GIVEN_DATE_TIME_OBSERVATION_CODE,
      linkId: AppConstants.fibrinolysisGivenLinkId,
      answerType: AppConstants.VALUE_TYPE_DATETIME
    },
    {
      code: AppConstants.FIRST_BALLOON_INFLATION_DEVICE_DATE_TIME_OBSERVATION_CODE,
      linkId: AppConstants.firstBalloonInflationDeviceLinkId,
      answerType: AppConstants.VALUE_TYPE_DATETIME
    }
  ];

}

export interface ITransactionBundle {
  firstBatch: fhirR4.Bundle;
  secondBatch: fhirR4.Bundle;
}
